import { Scene } from 'phaser';
import { TweenAction } from './TweenAction';

export class ScaleAction extends TweenAction {
  protected scaleX: number;
  protected scaleY: number;

  constructor(scene: Scene, targets: any, duration: number, scaleX: number, scaleY: number) {
    super(scene, targets, duration);
    this.scaleX = scaleX;
    this.scaleY = scaleY;
  }

  protected setTweenConfig() {
    super.setTweenConfig();
    this.setTweenConfigValue('scaleX', this.scaleX);
    this.setTweenConfigValue('scaleY', this.scaleY);
  }
}